import z from 'zod';
import { MFA_ACTIONS } from './mfa.enums';

export const TotpCodeSchema = z
  .string()
  .trim()
  .regex(/^\d{6}$/, 'totpCode must be 6 digits');

export const RecoveryCodeSchema = z
  .string()
  .trim()
  .regex(/^[A-Za-z0-9-]{10,12}$/, 'recoveryCode is malformed');

export const EnableMfaBodySchema = z.object({
  totpCode: TotpCodeSchema,
});

export const DisableMfaBodySchema = z
  .object({
    totpCode: TotpCodeSchema.optional(),
    recoveryCode: RecoveryCodeSchema.optional(),
  })
  .refine(
    (v) => !!v.totpCode !== !!v.recoveryCode,
    'Provide exactly one of totpCode or recoveryCode',
  );

export const MfaChallengeBodySchema = z.object({
  action: z.enum(MFA_ACTIONS),
});

export const MfaVerifyBodySchema = z
  .object({
    challengeToken: z.string().min(16, 'challengeToken is required'),
    totpCode: TotpCodeSchema.optional(),
    recoveryCode: RecoveryCodeSchema.optional(),
  })
  .refine(
    (v) => !!v.totpCode !== !!v.recoveryCode,
    'Provide exactly one of totpCode or recoveryCode',
  );
